<template>
  <master-layout pageTitle="Settings">
    <div class="vgrid--no-padding gridContainer">
        <div class="vrow vrow--start">
          <div
            v-for="(card, index) in filteredCards"
            :key="index"
            class="vcol vcol--no-padding vcol-xl-4 vcol-lg-12 vcol-md-12 vcol-sm-12 vcol-xs-12"
          >
            <div class="cardContainer" @click="$router.push(card.link)" role="button" tabindex="0" @keydown.enter="$router.push(card.link)">
              <div class="cardContent">
                <VIcon :name="card.icon" class="imgIcons" :size="-2"></VIcon>
                <div class="cardText">
                  <p class="vtext-card-title">{{ card.title }}</p>
                  <p class="vtext-subtitle vpt-5">{{ card.subtitle }}</p>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  </master-layout>
</template>

<script>
import { useAuthStore } from '@/stores/auth';

const allCards = [
  {
    title: "Business Profile",
    subtitle: "View and update your business details",
    icon: 'company-line',
    link: "/settings/account"
  },
  {
    title: "Manage Team Members",
    subtitle: "Manage who can access your account and their permissions",
    icon: 'group-permission-line',
    link: "/settings/team",
    key: "manageTeamMembers"
  },
  {
    title: "Live Chat Settings",
    subtitle: "Manage settings such as away message, message shortcuts, etc",
    icon: 'interactive-message-line',
    link: "/settings/live-chat",
    key: "liveChatSettings"
  },
  {
    title: "Password Settings",
    subtitle: "Manage settings related to password reset for all team member accounts",
    icon: 'lock-line',
    link: "/settings/password"
  },
  {
    title: "Data Privacy",
    subtitle: "Manage the privacy of your customer's data and safeguard their sensitive information",
    icon: 'shield-line',
    link: "/settings/data-privacy",
    key: "dataPrivacy"
  },
  {
    title: "SSO Settings",
    subtitle: "Manage settings related to Single Sign-On (SSO)",
    icon: 'unlock-line',
    link: "/settings/sso",
    key: "addons.sso"
  },
  {
    title: "Integrations",
    subtitle: "Connect and manage third-party integrations for enhanced customer engagement",
    icon: 'atoms-line',
    link: "/integrations"
  }
];

export default {
  computed: {
    isOwner() { return useAuthStore().isOwner; },
    isLoggedInViaSSO() { return useAuthStore().isLoggedInViaSSO; },
    permissions() { return useAuthStore().getPermissions ?? {}; },
    filteredCards() {
      return allCards.filter(e => {
        if(e.link === '/settings/sso' && !this.isOwner){
          return false;
        }
        
        if(e.link === '/settings/password' && this.isLoggedInViaSSO){
          return false;
        }

        // Show integrations card only if MoEngage or SFMC addon is available
        if(e.link === '/integrations') {
          return !!this.permissions?.addons?.moengage || !!this.permissions?.addons?.sfmc;
        }
        
        if (!e.key) return true;
        
        // Handle nested properties like "addons.sso"
        if (e.key.includes('.')) {
          const keys = e.key.split('.');
          let value = this.permissions;
          for (const key of keys) {
            value = value?.[key];
            if (value === undefined) return false;
          }
          return !!value;
        }
        
        return !!this.permissions[e.key];
      });
    }
  }
};
</script>

<style scoped>

.gridContainer {
  margin: 10px 20px;
}
.cardContainer {
  min-height: 120px;
  max-height: 130px;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  background: var(--white);
  border: 1px solid var(--white);
  box-shadow: none;
  margin: 10px;
  transition: border-color 0.2s ease;
}
.cardContainer:hover {
  border-color: var(--purple);
}
.cardContainer:focus-visible {
  outline: 2px solid var(--purple);
  outline-offset: 2px;
}
.cardContent {
  display: flex;
  align-items: center;
  padding: 0 20px;
  width: 100%;
}
.imgIcons {
  margin-right: 15px;
  flex-shrink: 0;
}
.cardText {
  flex: 1;
  min-width: 0;
}
@media only screen and (max-width: 780px) {
  .gridContainer {
    margin: 10px;
  }
}
</style>
